import ApiFaqPost from 'types/api/FaqPost';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import FaqPost from 'models/FaqPost';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    categoryId?: string;
    categorySlug?: string;
}
export const list = async (params?: ListParams): Promise<ListCollection<FaqPost>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicFaqPosts, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.FaqPosts];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiFaqPost) => new FaqPost(element)),
        meta: resource.meta,
    };
};
